import React, { useState } from 'react';
import { Loader2 } from "lucide-react";
import { toast, ToastContainer } from 'react-toastify';
import { syncItemsERP, syncItemsStockERP } from '../../../helpers/backend_helper';
import { Common } from 'helpers/common';

const SyncERP = () => {
    const uiHelper = new Common();

    const [isSyncingItems, setIsSyncingItems] = useState(false);
    const [isSyncingStock, setIsSyncingStock] = useState(false);

    const handleSyncItems = async () => {
        setIsSyncingItems(true);
        try {
            const response = await syncItemsERP();
            if (response.success) {
                uiHelper.showSuccessMessage('Items synced successfully to ERP');
            } else {
                uiHelper.showErrorMessage(response.message || 'Failed to sync items to ERP');
            }
        } catch (error: any) {
            uiHelper.showErrorMessage(error.message || 'An error occurred while syncing items');
        } finally {
            setIsSyncingItems(false);
        }
    };

    const handleSyncStock = async () => {
        setIsSyncingStock(true);
        try {
            const response = await syncItemsStockERP();
            if (response.success) {
                uiHelper.showSuccessMessage('Stock synced successfully to ERP');
            } else {
                uiHelper.showErrorMessage(response.message || 'Failed to sync stock to ERP');
            }
        } catch (error: any) {
            uiHelper.showErrorMessage(error.message || 'An error occurred while syncing stock');
        } finally {
            setIsSyncingStock(false);
        }
    };

    return (
        <div className="card mt-5">
            <ToastContainer closeButton={false} limit={1} />

            <div className="card-body">
                <h4 className="card-title mb-4">Sync with ERP</h4>
                
                <div className="flex flex-col gap-4">
                    <div className="flex items-center gap-4">
                        <button
                            type="button"
                            className="btn bg-custom-500 text-white border-custom-500 hover:bg-custom-600 hover:border-custom-600 focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:bg-custom-600 active:border-custom-600 disabled:opacity-50 disabled:cursor-not-allowed flex items-center whitespace-nowrap"
                            onClick={handleSyncItems}
                            disabled={isSyncingItems || isSyncingStock}
                        >
                            {isSyncingItems ? (
                                <div className="flex items-center">
                                    <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                                    <span>Syncing Items...</span>
                                </div>
                            ) : (
                                'Sync Items'
                            )}
                        </button>
                        <span className="text-slate-500">Sync all product items to ERP system</span>
                    </div>

                    <div className="flex items-center gap-4">
                        <button
                            type="button"
                            className="btn bg-custom-500 text-white border-custom-500 hover:bg-custom-600 hover:border-custom-600 focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:bg-custom-600 active:border-custom-600 disabled:opacity-50 disabled:cursor-not-allowed flex items-center whitespace-nowrap"
                            onClick={handleSyncStock}
                            disabled={isSyncingItems || isSyncingStock}
                        >
                            {isSyncingStock ? (
                                <div className="flex items-center">
                                    <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                                    <span>Syncing Stock...</span>
                                </div>
                            ) : (
                                'Sync Stock'
                            )}
                        </button>
                        <span className="text-slate-500">Sync current stock levels to ERP system</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SyncERP; 